import { z } from 'zod';

/**
 * Temp tag number validation schema
 * - Must be a non-empty string
 * - Optional for external workflows
 */
const tempTagNumberSchema = z.string().min(1, 'Temp tag number is required').optional();
/**
 * NAIC code validation schema
 * - Must be a non-empty string
 * - Optional for external workflows
 */
const naicCodeSchema = z.string().min(1, 'NAIC code is required').optional();
/**
 * Generate temp tag body schema (for POST /:orderId/generate-temp-tag)
 * Supports both Ekho workflow (tempTagNumber + naicCode) and external workflows (isConfirmed)
 */
const generateTempTagBodySchema = z.object({
    tempTagNumber: tempTagNumberSchema,
    naicCode: naicCodeSchema,
    isConfirmed: z.boolean().optional(), // For external workflows
});
/**
 * Generate temp tag Ekho workflow form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(generateTempTagEkhoFormSchema)
 */
const generateTempTagEkhoFormSchema = z.object({
    tempTagNumber: tempTagNumberSchema,
    naicCode: naicCodeSchema,
});
/**
 * Generate temp tag external workflow form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(generateTempTagExternalFormSchema)
 */
const generateTempTagExternalFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm temp tag generation',
    }),
});

export { generateTempTagBodySchema, generateTempTagEkhoFormSchema, generateTempTagExternalFormSchema, naicCodeSchema, tempTagNumberSchema };
//# sourceMappingURL=tempTagValidation.js.map
